/**
 * Test IDs for QA automation.
 */
export const testIds = {
  businessEntityDetailsDelete: "business-entity-details-delete",
  businessEntityDetailsEdit: "business-entity-details-edit",
  businessEntityDetailsPayToProfile: "business-entity-details-pay-to-profile",
  businessEntityDetailsWebsite: "business-entity-details-website",
  businessEntityDetailsCustomerPortalUrl: "business-entity-details-customer-portal-url",
  businessEntityDetailsCopyCustomerPortalUrl: "business-entity-details-copy-customer-portal-url",
  businessEntityDetailsContactWebsite: "business-entity-details-contact-website",
  businessEntityDetailsOpenDocument: "business-entity-details-open-document",
  businessEntityDetailsAddNoteToShipment: "business-entity-details-add-note-to-shipment",
  businessEntityDetailsClose: "business-entity-details-close",
} as const;
